const TELEGRAM_WIDGET_SRC = 'https://telegram.org/js/telegram-widget.js?15';

declare global {
  interface Window {
    Telegram?: {
      Login: {
        auth: (
          options: { bot_id: string | number; request_access?: boolean },
          callback: (data: Record<string, unknown> | false) => void,
        ) => void;
      };
    };
    TelegramBotId?: string;
    TelegramBotName?: string;
  }
}

let loadPromise: Promise<void> | null = null;

function isWidgetReady(): boolean {
  return Boolean(window.Telegram?.Login?.auth);
}

export function loadTelegramWidget(): Promise<void> {
  if (isWidgetReady()) {
    return Promise.resolve();
  }
  if (loadPromise) {
    return loadPromise;
  }

  loadPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector<HTMLScriptElement>(
      `script[src="${TELEGRAM_WIDGET_SRC}"]`,
    );
    const finish = () => {
      if (isWidgetReady()) {
        resolve();
        return;
      }
      loadPromise = null;
      reject(new Error('Telegram widget did not initialize'));
    };

    if (existing) {
      if (isWidgetReady()) {
        resolve();
        return;
      }
      existing.addEventListener('load', finish);
      existing.addEventListener('error', () => {
        loadPromise = null;
        reject(new Error('Failed to load Telegram widget'));
      });
      return;
    }

    const script = document.createElement('script');
    script.src = TELEGRAM_WIDGET_SRC;
    script.async = true;
    script.onload = finish;
    script.onerror = () => {
      loadPromise = null;
      reject(new Error('Failed to load Telegram widget'));
    };
    document.head.appendChild(script);
  });

  return loadPromise;
}
